module.exports = __webpack_public_path__ + "app/modals/show-api-key-modal.view.html";